class AjaxLoadMoreFocus {
    constructor() {
        // Listen globally because the same ALM behavior is used by multiple archives.
        document.addEventListener('focusin', this.handleFocus);
    }

    handleFocus = (event) => {
        // ALM moves focus to the new card wrapper after each load.
        const focusedItem = event.target;

        // .alm-listing is shared by every Ajax Load More listing, regardless of post type.
        if (
            !focusedItem.matches('[tabindex="-1"]') ||
            !focusedItem.closest('.alm-listing')
        ) {
            return;
        }

        // Find the actual interactive link inside the wrapper focused by ALM.
        const firstCardLink = focusedItem.querySelector('.card-our-story__link');

        // Move keyboard focus to the first newly loaded card link.
        if (firstCardLink) {
            firstCardLink.focus();
        }
    }
}

export default AjaxLoadMoreFocus;
